import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../Component/Header";
import Sidebar from "../Component/Sidebar";
import "../theme/master-admin.css";
import "../theme/components.css";

const RAIL_KEY = "MA_SIDEBAR_RAIL";

const readRail = () => {
  try { return localStorage.getItem(RAIL_KEY) === "1"; } catch { return false; }
};

const Layout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [rail, setRail] = useState<boolean>(readRail);
  const [sideOpen, setSideOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("USER_TOKEN");
    if (!token) navigate("/");
  }, [navigate]);

  // body class scopes the theme for modals/toasts rendered outside the shell
  useEffect(() => {
    document.body.classList.add("ma-body");
    return () => document.body.classList.remove("ma-body");
  }, []);

  // close the mobile drawer and go to top on every page change
  useEffect(() => {
    setSideOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  const toggleRail = () => {
    setRail(r => {
      try { localStorage.setItem(RAIL_KEY, r ? "0" : "1"); } catch { }
      return !r;
    });
  };

  return (
    <div className={`ma-app ${rail ? "rail" : ""}`}>
      <Sidebar open={sideOpen} onNavigate={() => setSideOpen(false)} onToggleRail={toggleRail} />
      {sideOpen && <div className="ma-scrim" onClick={() => setSideOpen(false)}></div>}
      <main className="ma-main">
        <Header onBurger={() => setSideOpen(true)} />
        <div className="ma-view">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
